import tw from "tailwind-styled-components";

export const PriceItemWrapper = tw.div`
  flex
  flex-col
  justify-between
  gap-6
  bg-gray-100
  rounded-2xl
  p-6
  pt-8
`;

export const ItemDescriptionContainer = tw.div`
  flex
  flex-col
  gap-6

  desktop:pt-2
  desktop:gap-8
`;

export const Title = tw.h3`
  text-center
  text-3xl
`;

export const ItemPriceContainer = tw.div`
  flex
  flex-col
  gap-8
`;

export const Price = tw.h3`
  text-center
  text-3xl
`;

export const PriceDescription = tw.p`
  text-center
  text-base
`;
